import React, { useEffect, useState } from 'react';
import './index.css';
import {
  Section,
  SearchIcon,
  Fieldset,
  Field,
  FieldBody,
  FieldLabel,
  Search,
  Table,
  TableBody,
  TableBodyRow,
  TableBodyCell,
  TableHeadCell,
  TableHead,
  TableHeadRow,
  Button,
  EditIcon,
  Toolbar,
  ToolbarItem,
  Select,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronHardStopIcon,
  Tooltip,
  TooltipContent,
  TooltipPassage,
  CircleQuestionMarkFilledIcon,
} from '@emorg-prd/react-standard';
import UpdateSite from './UpdateSite';
import OperationStatus from '../../../../api/OperationStatus';
import Site from '../../../../api/Site';
import LoaderIcon from '../../../loaderIcon';

const NewSearchSite = (props) => {
  let { isAuthorized } = props;
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [sourceRef, setSourceRef] = useState('');
  const [page, setPage] = useState(1);
  const [pageLength, setPageLength] = useState(10);
  const [filteredList, setFilteredList] = useState([]);
  const [pageList, setPageList] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [operationStatusList, setOperationStatusList] = useState([]);
  const [updateWindow, showUpdateWindow] = useState(false);
  const [selectedSiteId, setSelectedSiteId] = useState('');
  const [siteState, setSiteState] = useState({
    siteName: '',
    siteCode: '',
    siteOperationStatus: '',
    sitePrimaryUseType: '',
    siteOperationStatusId: '',
    sitePrimaryUseTypeId: '',
    siteOperationStatusIsActive: '',
    sitePrimaryUseTypeIsActive: '',
    itSiteCodeList: [],
    siteSourceLinkList: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(true);
  const [errorCode, setErrorCode] = useState('');

  const onChange = (field, value) => {
    setSiteState((prev) => ({ ...prev, [field]: value }));
  };

  const showLoadingSpinner = (value) => {
    setIsLoading(value);
  };

  useEffect(() => {
    showLoadingSpinner(true);
    Site.getAll().then((res) => {
      setSiteList(res);
      setFilteredList(res);
      setTotalResults(res.length);
      showLoadingSpinner(false);
    }).catch((error) => {
      handlePageError(error.message);
    });
    OperationStatus.getAll().then((res) => {
      setOperationStatusList(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
  }, []);

  useEffect(() => {
    let newSites;
    if (sourceRef) {
      newSites = siteList.filter((sites) =>
        sites.siteName.toLowerCase().trim()
          .includes(name.trim().toLowerCase()) &&
        sites.siteCode.toLowerCase().trim()
          .includes(code.trim().toLowerCase()) &&
        sites.siteSourceSystemRelate.some((siteSource) =>
          siteSource.sourceSystemReferenceId.includes(sourceRef)
        )
      );
    } else {
      newSites = siteList.filter((sites) =>
        sites.siteName.toLowerCase().trim()
          .includes(name.trim().toLowerCase()) &&
        sites.siteCode.toLowerCase().trim()
          .includes(code.trim().toLowerCase())
      );
    }
    setFilteredList(newSites);
    setPage(1);
    setPageList(newSites.slice(0, pageLength));
    setTotalResults(newSites.length);
  }, [name, code, siteList, sourceRef]);

  const renderSiteTable = (filteredList) => {
    return (
      <TableBodyRow className='table-row'>
        <TableBodyCell> {filteredList.siteName} </TableBodyCell>
        <TableBodyCell> {filteredList.siteCode} </TableBodyCell>
        <TableBodyCell>
          {' '}
          {operationStatusList
            .filter((status) =>
              status.operationStatusId === filteredList.operationStatusId
            )
            .map((status) => (
              <p>{status.operationStatusName}</p>
            ))}{' '}
        </TableBodyCell>
        <TableBodyCell>
          <Button
            variant='tertiary'
            style={{ paddingBottom: '20px', paddingRight: '30px' }}
            onClick={() => renderUpdateWindow(filteredList.siteId)}
          >
            <EditIcon />
          </Button>
        </TableBodyCell>
      </TableBodyRow>
    );
  };

  const renderUpdateWindow = (siteId) => {
    setSelectedSiteId(siteId);
    showUpdateWindow(true);
  };

  const changePageLength = (value) => {
    setPageLength(value);
    setPageList(filteredList.slice(0, value));
  };

  const handlePageChange = (direction) => {
    switch (direction) {
      case 0:
        setPageList(filteredList.slice(0, pageLength));
        setPage(1);
        break;
      case 1:
        if (page > 1) {
          setPageList(
            filteredList.slice(pageLength * (page - 2), pageLength * (page - 1))
          );
          setPage(page - 1);
        }
        break;
      case 2:
        if (page < Math.ceil(filteredList.length / pageLength)) {
          setPageList(filteredList.slice(pageLength * page, pageLength * (page + 1)));
          setPage(page + 1);
        }
        break;
      case 3:
        if (filteredList.length % pageLength === 0) {
          setPageList(
            filteredList.slice(filteredList.length - pageLength, filteredList.length)
          );
        } else {
          setPageList(
            filteredList.slice(
              filteredList.length - (filteredList.length % pageLength),
              filteredList.length
            )
          );
        }
        setPage(Math.ceil(filteredList.length / pageLength));
        break;
      default:
        break;
    }
  };

  const handlePageError = (message) => {
    switch (true) {
      case (message.includes('Network')):
        setErrorCode('Network');
        break;
      case (message.includes('400')):
        setErrorCode('Bad Request');
        break;
      case (message.includes('403')):
        setErrorCode('Forbidden');
        break;
      case (message.includes('404')):
        setErrorCode('Not Found');
        break;
      case (message.includes('500') || message.includes('Internal Server')):
        setErrorCode('Internal Server');
        break;
      case (message.includes('map')):
        setErrorCode('Mapping');
        break;
      default:
        break;
    }
    setPageLoaded(false);
  }

  return (
    <div className='site-page'>
      {pageLoaded && <div>
        {isLoading && <LoaderIcon />}
        <Section
          title={
            <div className='site-search-row'>
              <SearchIcon size='small' style={{ margin: '10px 0px 0px 5px' }} />
              <p style={{ margin: '0px 20px 0px 10px' }}>Search Site</p>
            </div>
          }
          underline='main'
        />
        <div>
          <Fieldset
            style={{
              padding: '0px',
              marginBottom: '0px',
              borderBottom: '1px solid #e5e5e5',
            }}
          >
            <Field style={{ margin: '0px' }}>
              <FieldLabel></FieldLabel>
              <FieldBody>
                <Search
                  style={{ padding: '0px 40px 0px 40px', width: '100%' }}
                  onSubmit={(e) => e.preventDefault()}
                  inputProps={{
                    value: name,
                    onChange: (e) => setName(e.target.value),
                    placeholder: 'Search Site Name',
                  }}
                  buttonProps={{
                    className: 'search-site-button-primary',
                  }}
                />

                <div className='site-search-row' style={{ padding: '20px 0px 0px 40px' }}>
                  <Field>
                    <FieldLabel> Site Code </FieldLabel>
                    <Search
                      style={{ width: '400px' }}
                      onSubmit={(e) => e.preventDefault()}
                      inputProps={{
                        value: code,
                        onChange: (e) => setCode(e.target.value),
                        placeholder: 'Search Site Code',
                      }}
                      buttonProps={{
                        variant: 'secondary',
                        className: 'search-site-button-secondary',
                      }}
                    />
                  </Field>
                  <Field style={{ marginLeft: '15px'}}>
                    <FieldLabel>
                      {" "}
                      Site Reference ID
                      <Tooltip>
                        <TooltipPassage>
                          <CircleQuestionMarkFilledIcon size='small' style={{ marginLeft: '5px', color: "#003366" }}/>
                        </TooltipPassage>
                        <TooltipContent>(Connexion, SID, etc) </TooltipContent>
                      </Tooltip>{" "}
                    </FieldLabel>

                    <Search
                      style={{ width: '400px' }}
                      onSubmit={(e) => e.preventDefault()}
                      inputProps={{
                        value: sourceRef,
                        onChange: (e) => setSourceRef(e.target.value),
                      }}
                      buttonProps={{
                        variant: 'secondary',
                        className: 'search-site-button-secondary',
                      }}
                    />
                  </Field>
                </div>
              </FieldBody>
            </Field>
          </Fieldset>

          <Fieldset
            style={{ backgroundColor: '#F5F5F5', borderBottom: '1px solid #e5e5e5' }}
          >
            <Table
              style={{ padding: '15px 40px 0px 40px', color: '#F5F5F5' }}
              footer={
                <Toolbar style={{ padding: '5px' }}>
                  <ToolbarItem left>{totalResults} results</ToolbarItem>
                  <ToolbarItem right>
                    <div className='paginator-row'>
                      <p style={{ paddingTop: '10px', paddingRight: '0px' }}>
                        Items per page:
                    </p>
                      <Select
                        value={pageLength}
                        onChange={(e) => changePageLength(e.target.value)}
                        style={{ paddingRight: '10px', paddingLeft: '0px' }}
                        selectProps={{
                          className: 'paginator-select',
                        }}
                      >
                        <option value='5'>5</option>
                        <option value='10'>10</option>
                        <option value='20'>20</option>
                      </Select>
                      <Button
                        onClick={(e) => handlePageChange(0)}
                        variant='tertiary'
                        style={{ padding: '0px', transform: 'rotateY(180deg)' }}
                      >
                        <ChevronHardStopIcon size='small' />
                      </Button>
                      <Button
                        onClick={(e) => handlePageChange(1)}
                        variant='tertiary'
                        style={{ padding: '0px 5px 0px 10px' }}
                      >
                        <ChevronLeftIcon size='small' />
                      </Button>
                      <Button
                        onClick={(e) => handlePageChange(2)}
                        variant='tertiary'
                        style={{ padding: '0px 10px 0px 5px' }}
                      >
                        <ChevronRightIcon size='small' />
                      </Button>
                      <Button
                        onClick={(e) => handlePageChange(3)}
                        variant='tertiary'
                        style={{ padding: '0px' }}
                      >
                        <ChevronHardStopIcon size='small' />
                      </Button>
                    </div>
                  </ToolbarItem>
                </Toolbar>
              }
            >
              <TableHead>
                <TableHeadRow>
                  <TableHeadCell> Site Name </TableHeadCell>
                  <TableHeadCell> Site Code </TableHeadCell>
                  <TableHeadCell> Operation Status </TableHeadCell>
                  <TableHeadCell style={{ width: '5px' }}> </TableHeadCell>
                </TableHeadRow>
              </TableHead>
              <TableBody>{pageList.map(renderSiteTable)}</TableBody>
            </Table>

            <UpdateSite
              {...siteState}
              siteList={siteList}
              setSiteList={setSiteList}
              selectedSite={selectedSiteId}
              onChange={onChange}
              isAuthorized={isAuthorized}
              handlePageError={handlePageError}
              updateWindow={updateWindow}
              closeWindow={() => showUpdateWindow(false)}
              showLoadingSpinner={showLoadingSpinner}
            ></UpdateSite>
          </Fieldset>
        </div>
      </div>}

      {!pageLoaded && <div>
        <h1 style={{ textAlign: 'center', fontSize: '2rem' }}>
          {errorCode} Error Occurred
        </h1>
      </div>}

    </div>
  );
};

export default NewSearchSite;
